var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50004 1.33398C4.82671 1.33398 1.83337 4.32732 1.83337 8.00065C1.83337 11.674 4.82671 14.6673 8.50004 14.6673C12.1734 14.6673 15.1667 11.674 15.1667 8.00065C15.1667 4.32732 12.1734 1.33398 8.50004 1.33398ZM11.6867 6.46732L7.90671 10.2473C7.81337 10.3407 7.68671 10.394 7.55337 10.394C7.42004 10.394 7.29337 10.3407 7.20004 10.2473L5.31337 8.36065C5.12004 8.16732 5.12004 7.84732 5.31337 7.65398C5.50671 7.46065 5.82671 7.46065 6.02004 7.65398L7.55337 9.18732L10.98 5.76065C11.1734 5.56732 11.4934 5.56732 11.6867 5.76065C11.88 5.95398 11.88 6.26732 11.6867 6.46732Z",
    fill: "#6F00FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.01c3612158019cbb2b39ee71053f7f31.svg";
export { ForwardRef as ReactComponent };